import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const HighlightPickItem2 = styled.div`
  .img-banner {
    position: relative;

    .img {
      /* padding-bottom: 102.985%; */
      height: ${mixin.pxToVw('345')};

      &:after {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.03);
      }
    }

    &:not(:has(.text-wrap)) {
      margin-bottom: 12px;

      .img {
        /* padding-bottom: 119.7014%; */
        height: calc(${mixin.pxToVw('345')} + 56px);
      }
    }

    .area-info {
      height: 68px;
      ${mixin.flex({
        justify: 'space-between',
        align: 'center',
      })};
      gap: 10px;
      padding: 12px 6px;

      /* 타이틀·서브타이틀이 모두 없는 케이스.
         MO는 이미지 아래 69px 텍스트 영역을 없애고 이미지 위 우하단에 화살표만 얹는다.
         PC는 원래 이미지 위 오버레이라 정렬만 우측으로 바꾼다(텍스트가 없으면
         space-between이 화살표를 좌측으로 밀어버림). */
      &.no-text {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: auto;
        z-index: 1;
        justify-content: flex-end;
        padding: 0 20px 20px 0;

        .icon-arrow {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          background: rgba(0, 0, 0, 0.3);

          svg path {
            fill: #fff;
          }
        }
      }

      .text-wrap {
        text-align: left;

        .text {
          position: relative;
          ${mixin.ellipsis(1)}
          color: #000;
          line-height: 130%;
        }

        .title {
          font-size: 18px;
          font-weight: 600;
          letter-spacing: -0.108px;
        }

        .desc {
          margin-top: 4px;
          font-size: 13px;
          letter-spacing: -0.078px;
        }
      }

      .icon-arrow {
        ${mixin.flex({})};
        width: 18px;
        height: 18px;
        flex-shrink: 0;
        z-index: 1;
        position: relative;

        svg path {
          fill: #000;
        }

        // 터치 영역 확장 (44x44, 노출 스타일은 변동 없음)
        &:after {
          content: '';
          display: block;
          position: absolute;
          top: 50%;
          right: -6px;
          transform: translateY(-50%);
          width: 44px;
          height: 44px;
        }
      }
    }

    .highlight-swiper {
      .swiper-pagination {
        bottom: 16px;
      }

      .swiper-pagination-bullet {
        background: #fff;
        opacity: 0.5;
        width: 4px;
        height: 4px;

        &.swiper-pagination-bullet-active {
          opacity: 1;
        }
      }
    }
  }

  .product-list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0 6px;
  }

  .btn-more-wrap {
    margin-top: 45px;
    text-align: center;

    .btn-more {
      border-radius: 100px;
      font-size: 14px;
      font-weight: 600;
      background: transparent;

      .text {
        font-weight: 600;
      }
    }
  }

  &:has(.product-list .area-tag) {
    .btn-more-wrap {
      margin-top: 16px;
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    .img-banner {
      &:not(:has(.text-wrap)) {
        margin-bottom: ${mixin.pxToVw('12')};

        .img {
          height: calc(${mixin.pxToVw('345')} + ${mixin.pxToVw('56')});
        }
      }

      .area-info {
        height: ${mixin.pxToVw('68')};
        gap: ${mixin.pxToVw('10')};
        padding: ${mixin.pxToVw('12 6')};

        &.no-text {
          height: auto;
          padding: ${mixin.pxToVw('0 20 20 0')};

          .icon-arrow {
            width: ${mixin.pxToVw('36')};
            height: ${mixin.pxToVw('36')};
          }
        }

        .text-wrap {
          .title {
            font-size: ${mixin.pxToVw('18')};
          }

          .desc {
            margin-top: ${mixin.pxToVw('4')};
            font-size: ${mixin.pxToVw('13')};
          }
        }

        .icon-arrow {
          position: relative;
          width: ${mixin.pxToVw('18')};
          height: ${mixin.pxToVw('18')};

          &:after {
            right: ${mixin.pxToVw('-6')};
            width: ${mixin.pxToVw('44')};
            height: ${mixin.pxToVw('44')};
          }
        }
      }

      .highlight-swiper {
        .swiper-pagination {
          bottom: ${mixin.pxToVw('16')};
        }

        .swiper-pagination-bullet {
          width: ${mixin.pxToVw('4')};
          height: ${mixin.pxToVw('4')};
        }
      }
    }

    .product-list {
      gap: ${mixin.pxToVw('0 6')};
    }

    .btn-more-wrap {
      margin-top: ${mixin.pxToVw('45')};

      .btn-more {
        border-radius: ${mixin.pxToVw('24')};
        font-size: ${mixin.pxToVw('14')};
      }
    }

    &:has(.product-list .area-tag) {
      .btn-more-wrap {
        margin-top: ${mixin.pxToVw('16')};
      }
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    display: flex;
    align-items: flex-start;
    gap: 12px;

    .img-banner {
      width: 340px;
      height: 453px;

      .img {
        /* padding-bottom: 133.2352%; */
        width: 340px;
        height: 453px;
      }

      &:not(:has(.text-wrap)) {
        margin-bottom: unset;

        .img {
          /* padding-bottom: 133.2352%; */
          width: 340px;
          height: 453px;
        }
      }

      .area-info {
        width: 100%;
        height: auto;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1;
        background: linear-gradient(
          180deg,
          rgba(0, 0, 0, 0) 0%,
          rgba(0, 0, 0, 0.5) 100%
        );
        align-items: flex-end;
        gap: 16px;
        padding: 20px 16px 42px 16px;

        /* PC는 이미 오버레이라 여백만 PC값으로 되돌린다(정렬은 base의 flex-end 유지) */
        &.no-text {
          padding: 20px 20px 42px 20px;
        }

        .text-wrap {
          width: 256px;

          .text {
            color: #fff;
          }

          .title {
            font-size: 20px;
            /* ${mixin.ellipsis(2)} */
            letter-spacing: -0.12px;
          }

          .desc {
            margin-top: 6px;
            font-size: 14px;
            letter-spacing: -0.084px;
          }
        }

        .icon-arrow {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          background: rgba(0, 0, 0, 0.3);

          svg path {
            fill: #fff;
          }

          &:after {
            display: none;
          }
        }

        &:not(:has(.icon-arrow)) {
          .text-wrap {
            width: 100%;
          }
        }
      }

      .highlight-swiper {
        .swiper-pagination {
          bottom: 20px;
        }

        .swiper-pagination-bullet {
          width: 6px;
          height: 6px;
          margin: 0 3px;
        }
      }
    }

    .product-list-wrap {
      flex: 1 1 auto;
      min-width: 0;
    }

    .product-list {
      display: flex;
      flex-direction: column;
      gap: 8px;

      .type-list .area-info .area-click .prdc-title .detail {
        ${mixin.ellipsis(2)}
      }

      .type-list .area-img {
        width: 80px !important;

        .img {
          padding-bottom: 133.75%;
        }
      }
    }
  }
`;
